import keys from "lodash/keys";
import startCase from "lodash/startCase";
import toLower from "lodash/toLower";
import { showError } from "./action/NotificationsActions";
export * from "./action/NotificationsActions";
export * from "./action/NotificationsActionsTypes";
export * from "./model/Notifications";
export * from "./middleware/NotificationsMiddleware";
export * from "./reducer/NotificationsReducer";
export * from "./reducer/NotificationsState";
var UNPROCESSABLE_ENTITY = 422;
export var alertErrorHandler = function (apiError, dispatch, genericErrorMessage) {
    var _a, _b, _c, _d, _e;
    if (((_a = apiError.response) === null || _a === void 0 ? void 0 : _a.status) === UNPROCESSABLE_ENTITY && ((_c = (_b = apiError.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.base)) {
        apiError.response.data.base.forEach(function (errorMessage) { return dispatch(showError(errorMessage)); });
    }
    else if (((_d = apiError.response) === null || _d === void 0 ? void 0 : _d.status) === UNPROCESSABLE_ENTITY && ((_e = apiError.response) === null || _e === void 0 ? void 0 : _e.data)) {
        keys(apiError.response.data).forEach(function (key) {
            var field = startCase(toLower(key).replaceAll("_", " "));
            if (key.toLowerCase() === "error") {
                dispatch(showError(apiError.response.data[key]));
            }
            else {
                dispatch(showError("".concat(field, " ").concat(apiError.response.data[key])));
            }
        });
    }
    else {
        dispatch(showError(genericErrorMessage));
    }
};
export var alertErrorWihtoutFieldHandler = function (apiError, dispatch, genericErrorMessage) {
    var _a, _b;
    if (((_a = apiError.response) === null || _a === void 0 ? void 0 : _a.status) === UNPROCESSABLE_ENTITY && ((_b = apiError.response) === null || _b === void 0 ? void 0 : _b.data)) {
        keys(apiError.response.data).forEach(function (key) {
            dispatch(showError("".concat(apiError.response.data[key])));
        });
    }
    else {
        dispatch(showError(genericErrorMessage));
    }
};
